import { h } from 'vue'

export const InventoryRequirementCell = {
  functional: true,
  render(createElement, { props }) {
    const inventoryRequirements = props.value || []
    const firstInventoryRequirement = inventoryRequirements[0] || ''
    const count = inventoryRequirements.length || 0

    if (count > 1) {
      return h('span', [firstInventoryRequirement, h('strong', ` + more`)])
    }

    return h('span', firstInventoryRequirement)
  },
}
